import {Component, ContentChildren, ElementRef, input, OnInit, output, OutputRefSubscription, QueryList} from '@angular/core';
import {AccordionItemComponent} from "./accordion-item/accordion-item.component";

@Component({
  selector: 'app-accordion-list',
  templateUrl: './accordion-list.component.html',
  styleUrls: ['./accordion-list.component.scss']
})
export class AccordionListComponent implements OnInit {

  @ContentChildren(AccordionItemComponent) items!: QueryList<AccordionItemComponent>;

  onExpanded = output();
  single = input<boolean>();

  private subs: OutputRefSubscription[] = [];

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    this.bindItems();
    this.subs.push(this.items.changes.subscribe(() => this.bindItems()));
  }

  closeAll() {
    this.items.forEach(item => item.expanded.set(false));
  }

  private bindItems(): void {
    this.subs.filter((_, i) => i > 0).forEach(s => s.unsubscribe());
    this.subs = this.subs.slice(0, 1);

    this.items.forEach(item => {
      this.subs.push(
        item.expandedChange.subscribe((open: boolean) => {

          if (open) {
            this.onExpanded.emit();
            this.scrollItemIntoView(item);
          }

          if (open && this.single()) {
            this.closeOthers(item);
          }
        })
      );
    });
  }

  private scrollItemIntoView(item: AccordionItemComponent): void {
    setTimeout(() => {
      const el = (item as any).elementRef?.nativeElement as HTMLElement;
      el?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 250); // delay per dare tempo all'animazione di apertura
  }

  private closeOthers(current: AccordionItemComponent): void {
    this.items.forEach(item => {
      if (item !== current && item.expanded()) {
        item.expanded.set(false);
        item.expandedChange.emit(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

}
